module.exports = __webpack_public_path__ + "img/doc.0640468c.png";